import { render, staticRenderFns } from "./CouponInfo.vue?vue&type=template&id=1e5a8a4c&scoped=true&"
import script from "./CouponInfo.vue?vue&type=script&lang=js&"
export * from "./CouponInfo.vue?vue&type=script&lang=js&"
import style0 from "./CouponInfo.vue?vue&type=style&index=0&id=1e5a8a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5a8a4c",
  null
  
)

export default component.exports